import Export16 from '@carbon/icons-react/es/export/16';
import OpenPanelFilledLeft20 from '@carbon/icons-react/es/open-panel--filled--left/20';
import View16 from '@carbon/icons-react/es/view/16';
import { Tooltip, Typography } from 'antd';
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useHistory } from 'react-router';
import styled from 'styled-components';
import { FormInstanceApi, FormInstancesByProject } from 'api/form';
import { Button } from 'components/atoms/button';
import { ActionBar } from 'components/molecules/action-bar';
import { useTranslation } from 'hooks/use-translation';
import { useQueryAllAnswersByFormInstanceKey } from 'queries/form-instance';
import { FormResponseTable } from './form-response-table';
import { Content, Layout, Sider } from './form-responses.styles';
import { FormSider } from './sider';

type FormResponsesPropTypes = {
  projectFormInstance: FormInstancesByProject;
  instanceId: number;
};

const StyledActionBar = styled(ActionBar)`
  padding: var(--spacing-03) 0 !important;
  position: sticky;
  top: 0;
  z-index: var(--zindex-layer-02);
  box-shadow: var(--shadow-02);
  --action-bar-background: var(--white-100) !important;
`;

const ViewFormDetailWrapper = styled.div`
  padding-left: var(--spacing-05);
  padding-right: var(--spacing-05);
`;

const StyledText = styled(Typography.Text)`
  color: var(--cool-gray-70);
`;

const ExportButton = styled(Button)`
  aspect-ratio: 1;
  padding: 0;
  > svg {
    margin: auto;
  }
`;

export const FormResponses = ({
  projectFormInstance,
  instanceId,
}: FormResponsesPropTypes) => {
  const sidebarCollapseText = useTranslation('collapse_sidebar');
  const [siderbarVisibility, setSidebarVisibility] = useState(true);
  const history = useHistory();
  const { data: formInstanceAnswers } =
    useQueryAllAnswersByFormInstanceKey(instanceId);

  const exportAsCSV = () => {
    FormInstanceApi.exportFormAnswersByInstance(instanceId).then(
      (downloadUrl) => {
        window.open(downloadUrl, '_blank');
      },
    );
  };

  return (
    <Layout>
      {siderbarVisibility ? (
        <Sider>
          <FormSider
            projectFormInstance={projectFormInstance}
            activeKey={instanceId}
          />
        </Sider>
      ) : null}
      <Content>
        <StyledActionBar>
          <ActionBar.Primary>
            <Tooltip title={sidebarCollapseText}>
              <Button
                type="text"
                size="small"
                onClick={() => setSidebarVisibility(!siderbarVisibility)}
              >
                <OpenPanelFilledLeft20 color="var(--blue-60)" />
              </Button>
            </Tooltip>
            <StyledText ellipsis={{ tooltip: true }}>
              {formInstanceAnswers?.taskName}
            </StyledText>
          </ActionBar.Primary>
          <ActionBar.Secondary>
            <ExportButton type="text" size="small" onClick={exportAsCSV}>
              <Export16 />
            </ExportButton>
            {!!formInstanceAnswers && (
              <ViewFormDetailWrapper>
                <Button
                  size="small"
                  icon={<View16 />}
                  iconPlacement="right"
                  type="tertiary"
                  onClick={() =>
                    history.push(
                      `#task_drawer=${formInstanceAnswers.projectId}.${formInstanceAnswers.taskId}`,
                    )
                  }
                >
                  <FormattedMessage id="forms.response.view_form_detail" />
                </Button>
              </ViewFormDetailWrapper>
            )}
          </ActionBar.Secondary>
        </StyledActionBar>
        <FormResponseTable
          projectFormInstance={projectFormInstance}
          instanceId={instanceId}
        />
      </Content>
    </Layout>
  );
};
